import { Component, HostListener, Inject } from "@angular/core";
import { DOCUMENT } from "@angular/platform-browser";
import { Router, ActivatedRoute, Params } from "@angular/router";
import CBAErrorHandler from "../error/error.handler";

// import * as $ from "jquery";
import * as _ from "underscore";
declare var Carousel: any;
import * as moment from "moment";
import { ExportProductsService } from "./export_products.service";
import { FiltersService } from "./filters.service";
declare var $: any;

@Component({
  selector: "app-products",
  templateUrl: "./products.component.html",
  styleUrls: ["./products.component.css"],
  providers: [ExportProductsService, FiltersService]
})
export class ExportProductsComponent {
  private isSearchHidden: boolean = true;
  private isNavHidden = true;

  private isLoading = true;

  private products = null;
  private originalProducts = null;

  private listName = null;
  private displaySeason = null;
  private listId = null;
  private userId = null;
  private imageUnavailablePath = "/assets/images/image_unavailable_medium.jpg";
  private activeAsrt = null;
  private asrtHeaderHeight = 170;
  private asrtContent;
  private isChangeListHidden = true;
  private isCustomerList = false;
  private isCustomerLoggedIn = false;
  public magicLink = null;
  private region = null;
  private season = null;

  private filterData = null;
  private filterKeys = null;
  public queryFilterData = null;
  public downloadOptions = false;
  public onDisplayBiggerImage = false;
  public required_token = false;
  public topImageIndex;
  public asrtImageIndex;
  public collImageIndex;
  public groupColorIndex;
  public topImage = {};
  public thumbImageIndex;
  public groupedColors;
  public idIndex = {};
  public clickableIdx;
  public activeIdx;
  public activeRowIndex;
  public activeCollIndex;
  public activeAsrtIndex;

  public activeImgIdx = 0;
  country;

  public filterVals = null;
  public filterAllValues = [];
  public updatedFacetValues = [];
  public filter_data;
  public activeFilter = false;
  public filterSelected;
  public retailFilterValues;
  public retailFiltVals;
  updatedValues: any = {};
  public filterModal: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private productsService: ExportProductsService,
    private filtersService: FiltersService
  ) {
    // if (localStorage.hasOwnProperty("user_details")) {
    //   localStorage.removeItem("user_details");
    // }
    // if (localStorage.hasOwnProperty("appliedFilterValues")) {
    //   localStorage.removeItem("appliedFilterValues");
    // }
    let storedKey = ["user_details", "appliedFilterValues", "display_season"];
    this.removeKeysLocalStorage(storedKey);

    this.route.params.subscribe((params: Params) => {
      let magicLink = params["shortId"];
      if (magicLink) {
        this.magicLink = magicLink;
        this.setMagicLink(this.magicLink);
        this.loadProducts({ required_token: this.required_token });
      } else {
        //this is deprecated
        this.route.queryParams.subscribe((params: Params) => {
          this.magicLink = params["magic_link"];
          this.setMagicLink(this.magicLink);
          this.loadProducts({ required_token: this.required_token });
        });
      }

      let retailFilt = localStorage.getItem("filter_values");
      if (retailFilt && retailFilt.length > 0) {
        this.filterKeys = JSON.parse(retailFilt);
      }
      let filetrs = localStorage.getItem("appliedFilterValues");
      if (filetrs && Object.keys(filetrs).length > 0) {
        this.updatedValues = JSON.parse(filetrs);
        this.udpateFilterFacets();
      }
    });
  }

  setMagicLink(param) {
    let magicLink = localStorage.getItem("magic_link");
    if (param != magicLink) {
      this.required_token = true;
      localStorage.setItem("magic_link", param);
    }
  }

  removeKeysLocalStorage(keys) {
    for (let k of keys) {
      if (localStorage.hasOwnProperty(k)) {
        localStorage.removeItem(k);
      }
    }
  }

  ngOnInit() {
    $(window)
      .scroll(function () {
        var scrollDistance = $(window).scrollTop() + 300;

        // Assign active class to nav links while scolling
        $(".page-sections").each(function (i) {
          if ($(this).position().top <= scrollDistance) {
            $(".navmenu ul li a.active").removeClass("active");
            $(".navmenu ul li a").eq(i).addClass("active");
          }
        });
      })
      .scroll();
  }

  removeFilterFacet(val) {
    this.updatedFacetValues = this.updatedFacetValues.filter(
      (as) => !(as.key == val.key && as.subKey == val.subKey)
    );
    if (val.key && this.updatedValues[val.key]) {
      if (
        this.updatedValues[val.key] &&
        this.updatedValues[val.key].includes(val.subKey)
      ) {
        let index = this.updatedValues[val.key].indexOf(val.subKey);
        this.updatedValues[val.key].splice(index, 1);
      }

      localStorage.setItem(
        "appliedFilterValues",
        JSON.stringify(this.updatedValues)
      );

      this.refreshProduct();
    }
  }

  clearAllFilters() {
    this.updatedValues = {};
    this.updatedFacetValues = [];
    localStorage.setItem(
      "appliedFilterValues",
      JSON.stringify(this.updatedValues)
    );
    this.refreshProduct();
  }

  onDownload(): any {
    this.downloadOptions = !this.downloadOptions;
  }
  closeDownloadOptions(): any {
    this.downloadOptions = false;
  }

  clickNavMenu(asrt) {
    var mobileWindow = $(window).width() <= 800;
    if (mobileWindow) {
      $(".navbar-toggle").click();
    }
    $("html,body").animate(
      {
        scrollTop: $("#" + asrt.classname).offset().top - 200,
      },
      1000
    );
    return false;
  }

  loadProducts(filter = {}, isFilterApplied = false) {
    this.isLoading = !isFilterApplied;

    this.productsService
      .getProducts(this.magicLink, filter)
      .then((res) => {
        if (res) {
          this.season = res.season;
          this.region = res.name;
          this.country = res.country;
          this.listId = res.list_id;
        }
        if (res.list_name) {
          this.listName = res.list_name;
        }
        if (res.display_season) {
          this.displaySeason = res.display_season;
        }

        this.products = this.formatProducts(res);
        this.originalProducts = Object.assign({}, this.products);

        if (this.products["assortments"] && this.products["assortments"][0]) {
          this.activeAsrt = this.products["assortments"][0]["classname"];
        }
        if (this.updatedValues && this.updatedValues.length == 0) {
          this.isLoading = false;
          this.scrollToSelectedProduct();
        }
        return this.filtersService.getFilters(
          this.season,
          this.region,
          this.listId,
          this.country
        );
      })
      .then((res) => {
        this.filterData = res.filters;
        this.formatFilterOrders();
      })
      .then((res) => {
        this.isLoading = false;
        this.required_token = false;
        this.scrollToSelectedProduct();
      })
      .catch((e) => {
        this.handleError(e);
        this.isLoading = false;
      });
  }

  scrollToSelectedProduct() {
    if (localStorage.hasOwnProperty("product_data")) {
      let scrollToProduct = localStorage.getItem("product_data");
      let itemWithoutDot = scrollToProduct.replace(/\./g, "");
      let itemWithoutSpace = itemWithoutDot.replace(/\s+/g, "-");
      let mobileScreen = $(window).width() <= 1100;
      if (mobileScreen) {
        setTimeout(() => {
          $("html,body").animate(
            {
              scrollTop: $("#" + itemWithoutSpace).offset().top - 35,
            },
            1000
          );
        }, 1000);
      } else {
        setTimeout(() => {
          $("html,body").animate(
            {
              scrollTop: $("#" + itemWithoutSpace).offset().top - 253,
            },
            1000
          );
        }, 1000);
      }

      localStorage.removeItem("product_data");
    }
  }

  sortItems(a, b) {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  }

  formatProducts(data) {
    for (let asrt of data["assortments"]) {
      asrt["classname"] = this.sanitiseName(asrt.name);
      for (let coll of asrt["collections"]) {
        // coll["items"] = coll["items"].sort(this.sortItems);
        for (let item of coll["items"]) {
          item["detailclass"] = this.sanitiseNameWithoutDot(item.name, item.id);
          item["groupedColors"] = [];
          let i = 0;
          let tmpColors = [];
          let allcolors = this.getAllIds(item);
          for (let color of item["colors"]) {
            if (color && color.rrp_price) {
              let rrp = color.rrp_price;
              if (rrp.value != "0") {
                if (rrp.value && Array.isArray(rrp.value)) {
                  color["rrp"] = rrp.value.map(v => rrp.code + " " + v);
                } else {
                  color["rrp"] = rrp.code + " " + rrp.value;
                }
                color["is_us"] = rrp.code == "USD" ? true : false;
              }
            }

            color["style"] = item.name;
            color["lining"] = item.lining;
            color["sock"] = item.sock;
            color["upper"] = item.upper;
            color["construction"] = item.construction;
            color["sole"] = item.sole;
            color["fit"] = item.fit;
            color["status"] = item.status;
            color["all_colors"] = allcolors.toString();
            color["heel_height"] = item.heel_height;

            tmpColors.push(color);
            i += 1;
            //So, only 4 colors will be shown in one row
            if (i % 4 == 0) {
              item["groupedColors"].push(tmpColors);
              tmpColors = [];
            }
          }
          if (tmpColors.length > 0) {
            item["groupedColors"].push(tmpColors);
          }
        }
      }
    }
    return data;
  }

  getAllIds(item) {
    let colorList = [];
    for (let col of item["colors"]) {
      colorList.push(col.id);
    }
    return _.uniq(colorList);
  }

  sanitiseName(asrtName) {
    return asrtName.split(" ").join("-");
  }

  sanitiseNameWithoutDot(itemName, itemId) {
    let itemWithoutDot = itemName.replace(/\./g, "");
    let itemWithoutSpace = itemWithoutDot.replace(/\s+/g, "-");
    return itemWithoutSpace;
  }

  getThumbImage(image) {
    if (image) {
      return image;
    } else {
      return this.imageUnavailablePath;
    }
  }

  toggleNav() {
    this.isNavHidden = !this.isNavHidden;
  }

  handleError(e) {
    console.error(e);

    if (e._body) {
      try {
        let serverResponse = JSON.parse(e._body);
        e.statusText = serverResponse["message"];
      } catch (e) {}
    }

    if (e.status === 403) {
      this.router.navigateByUrl("/error/not-authorised");
    } else if (e.status === 404) {
      this.router.navigateByUrl("/error/not-found");
    } else {
      let errorHandler = new CBAErrorHandler();
      //errorHandler.notifyRaven(e);
      this.router.navigateByUrl("/error/internal-error");
    }
  }

  formatFilterOrders() {
    if (
      this.filterData &&
      Array.isArray(this.filterData) &&
      this.filterData.length > 0
    ) {
      this.filterKeys = this.filterData.map((as) => as.label);
      localStorage.setItem("filter_values", JSON.stringify(this.filterKeys));
    } else {
      this.filterKeys = [];
    }
  }

  showFilterModal() {
    this.filterModal = true;
  }

  closeFilterModal() {
    this.filterModal = false;
  }

  updateFilterValue(key, valIdx, val, isChecked) {
    if (isChecked) {
      if (!this.updatedValues[key]) {
        this.updatedValues[key] = [];
      }
      if (!this.updatedValues[key].includes(val)) {
        this.updatedValues[key].push(val);
      }
      localStorage.setItem(
        "appliedFilterValues",
        JSON.stringify(this.updatedValues)
      );
    } else {
      if (this.updatedValues && this.updatedValues[key]) {
        if (this.updatedValues[key].includes(val)) {
          let index = this.updatedValues[key].indexOf(val);
          this.updatedValues[key].splice(index, 1);
        }
      }
    }

    localStorage.setItem(
      "appliedFilterValues",
      JSON.stringify(this.updatedValues)
    );

    this.udpateFilterFacets();
    this.refreshProduct();
  }

  isFilterValueChecked(key, value, valIdx) {
    return (
      this.updatedValues &&
      this.updatedValues[key] &&
      this.updatedValues[key].indexOf(value) > -1
    );
  }

  refreshProduct() {
    let filters = {
      filter: this.getRequiredFilters(),
    };
    this.loadProducts(filters);
  }

  getRequiredFilters() {
    let newFilters = {};
    for (let f of Object.keys(this.updatedValues)) {
      if (this.updatedValues[f] && this.updatedValues[f].length > 0) {
        newFilters[f] = this.updatedValues[f];
      }
    }
    return JSON.stringify(newFilters);
  }

  udpateFilterFacets() {
    let filterArr = [];
    for (let i of Object.keys(this.updatedValues)) {
      if (this.updatedValues[i] && this.updatedValues[i].length > 0) {
        for (let f of this.updatedValues[i]) {
          let obj = {};
          obj["key"] = i;
          obj["originalKey"] = i; // we can change in what way we want to show
          obj["subKey"] = f;
          obj["originalSubkey"] = f;
          filterArr.push(obj);
        }
      }
    }
    this.updatedFacetValues = filterArr;
  }

  showFilterValues(key) {
    if (this.filterData && this.filterData.length > 0) {
      let filterVal = this.filterData.filter((as) => as.label == key);
      if (filterVal && filterVal[0] && filterVal[0].options) {
        this.filterAllValues = filterVal[0].options;
        this.filterVals = filterVal[0].key;
      }
    }
  }

  hideFilterVals() {
    this.filterVals = null;
  }

  orderPairs(color) {
    if (!color.orders) {
      return "0";
    }
    let retval = 0;
    for (let order in color.orders) {
      let val = parseInt(color.orders[order]);

      retval += isNaN(val) ? 0 : val;
    }
    return retval.toLocaleString("en-gb");
  }

  orderTotal(color) {
    if (!color.wholesale) {
      return "0";
    }
    return (
      parseInt(this.orderPairs(color).replace(/,/g, "")) * color.wholesale
    ).toLocaleString("en-gb");
  }

  openProduct(e, asrt, coll, item, color, season, country, listId) {
    this.router.navigate(["/product-summary"], {
      queryParams: {
        assortment: asrt.name,
        collection: coll.name,
        style: item.name,
        color: color.id,
        colors: color.all_colors,
        season: season,
        country: country || color.country,
        listId: listId,
      },
    });
  }
  overallPairs() {
    let totalPairs = 0;
    for (let assortment of this.products.assortments) {
      for (let coll of assortment.collections) {
        for (let item of coll.items) {
          for (let color of item.colors) {
            let val = parseInt(this.orderPairs(color));
            totalPairs += isNaN(val) ? 0 : val;
          }
        }
      }
    }
    return totalPairs.toLocaleString("en-gb");
  }

  overallTotal() {
    let total = 0;
    for (let assortment of this.products.assortments) {
      for (let coll of assortment.collections) {
        for (let item of coll.items) {
          for (let color of item.colors) {
            let val = parseInt(this.orderTotal(color).replace(/,/g, ""));
            total += isNaN(val) ? 0 : val;
          }
        }
      }
    }
    return total.toLocaleString("en-gb");
  }
}



// WEBPACK FOOTER //
// ./src/app/products/export_products.component.ts